import React, { useEffect, useMemo, useState } from 'react';
import { Nav, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import {
    House,
    Person,
    List,
    X,
    Folder,
    Tag,
    FileText,
} from 'react-bootstrap-icons';
import { useMediaQuery } from 'react-responsive';
import { useSelector } from 'react-redux';

/**
 * 侧边栏组件
 * 提供系统的主要导航功能
 * @returns {JSX.Element} 返回侧边栏组件
 */
function Sidebar() {
    const location = useLocation();
    const isMobile = useMediaQuery({ maxWidth: 991 });
    const [isOpen, setIsOpen] = useState(!isMobile);
    const { currentUser } = useSelector((state) => state.user);

    // 导航菜单配置
    const menuItems = useMemo(() => {
        const baseItems = [
            { path: '/', icon: <House className="me-2" />, label: '首页' },
            {
                path: '/doctors',
                icon: <Person className="me-2" />,
                label: '医生管理',
            },
        ];

        // 知识库管理菜单（始终显示）
        const knowledgeItems = [
            {
                label: '知识库管理',
                isGroup: true,
                children: [
                    {
                        path: '/documents',
                        icon: <FileText className="me-2" />,
                        label: '文档管理',
                    },
                    {
                        path: '/categories',
                        icon: <Folder className="me-2" />,
                        label: '分类管理',
                    },
                    {
                        path: '/tags',
                        icon: <Tag className="me-2" />,
                        label: '标签管理',
                    },
                ],
            },
        ];

        return [...baseItems, ...knowledgeItems];
    }, []);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    // 移动端点击导航项后自动关闭侧边栏
    const handleNavClick = () => {
        if (isMobile) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        const flag = menuItems.filter((item) => item.path === '/store');
        if (
            (currentUser?.name === '13321191756' ||
                currentUser?.name === '123' ||
                currentUser?.name === '15151416319' ||
                currentUser?.name === '15879897164') &&
            flag.length === 0
        ) {
            menuItems.push({
                path: '/store',
                icon: <Person className="me-2" />,
                label: '设备管理',
            });
        }
    }, [currentUser, menuItems]);

    return (
        <>
            {/* 移动端的汉堡菜单按钮 */}
            {isMobile && (
                <Button
                    variant="light"
                    className="sidebar-toggle"
                    onClick={toggleSidebar}
                >
                    {isOpen ? <X size={24} /> : <List size={24} />}
                </Button>
            )}

            <div
                className={`sidebar bg-white border-end ${
                    isMobile ? 'mobile' : ''
                } ${isOpen ? 'open' : ''}`}
            >
                <Nav className="flex-column p-3">
                    {menuItems.map((item, index) => {
                        if (item.isGroup) {
                            return (
                                <div key={index} className="nav-group mb-3">
                                    <div className="nav-group-title text-muted small fw-bold mb-2 px-2">
                                        {item.label}
                                    </div>
                                    {item.children.map((child) => (
                                        <Nav.Link
                                            key={child.path}
                                            as={Link}
                                            to={child.path}
                                            className={`mb-1 ms-2 ${
                                                location.pathname === child.path
                                                    ? 'active'
                                                    : ''
                                            }`}
                                            onClick={handleNavClick}
                                        >
                                            {child.icon}
                                            <span className="nav-label">
                                                {child.label}
                                            </span>
                                        </Nav.Link>
                                    ))}
                                </div>
                            );
                        } else {
                            return (
                                <Nav.Link
                                    key={item.path}
                                    as={Link}
                                    to={item.path}
                                    className={`mb-2 ${
                                        location.pathname === item.path
                                            ? 'active'
                                            : ''
                                    }`}
                                    onClick={handleNavClick}
                                >
                                    {item.icon}
                                    <span className="nav-label">
                                        {item.label}
                                    </span>
                                </Nav.Link>
                            );
                        }
                    })}
                </Nav>
            </div>

            {/* 移动端遮罩层 */}
            {isMobile && isOpen && (
                <div className="sidebar-backdrop" onClick={toggleSidebar} />
            )}
        </>
    );
}

export default Sidebar;
